var _g, _g2, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Livello_1",
    x: "0px",
    y: "0px",
    enableBackground: "new 0 0 595.3 258.6",
    xmlSpace: "preserve",
    viewBox: "64.79 88.96 457.34 97.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 64.7898 153.3965)",
    fill: "#181818",
    fontFamily: "'Montserrat-Regular'",
    fontSize: "59.732px"
  }, "D"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 112.2674 153.3965)",
    fill: "#181818",
    fontFamily: "'Montserrat-Regular'",
    fontSize: "59.732px"
  }, "A"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 157.5369 153.3965)",
    fill: "#181818",
    fontFamily: "'Montserrat-Regular'",
    fontSize: "59.732px"
  }, "Y"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 196.7742 153.3965)",
    fill: "#181818",
    fontFamily: "'Montserrat-Regular'",
    fontSize: "59.732px"
  }, "O"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 246.3435 153.3965)",
    fill: "#181818",
    fontFamily: "'Montserrat-Regular'",
    fontSize: "59.732px"
  }, "F"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 281.8767 153.3965)",
    fill: "#181818",
    fontFamily: "'Montserrat-Regular'",
    fontSize: "59.732px"
  }, "F"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 317.4109 153.3965)",
    fill: "#181818",
    fontFamily: "'Montserrat-Regular'",
    fontSize: "59.732px"
  }, "I"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 336.6433 153.3965)",
    fill: "#181818",
    fontFamily: "'Montserrat-Regular'",
    fontSize: "59.732px"
  }, "C"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 379.4637 153.3965)",
    fill: "#181818",
    fontFamily: "'Montserrat-Regular'",
    fontSize: "59.732px"
  }, "E"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M517.2,100.5L517.2,100.5l-93.4-11.5l0,0c-1.8-0.2-3.7,0.4-4.9,2c-1.1,1.4-1.3,3.1-0.9,4.7l0,0l0,0.1      c0.1,0.3,0.2,0.6,0.3,0.8l34.8,86.3l0,0c0.3,1,0.9,1.8,1.7,2.5c2.3,1.8,5.6,1.4,7.4-0.9l58.8-75.4c1.8-2.3,1.4-5.6-0.9-7.4      C519.2,100.9,518.2,100.5,517.2,100.5z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 435.1269,
    y1: 133.3857,
    x2: 470.3417,
    y2: 133.3857
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#009FE3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04166079,
    style: {
      stopColor: "#07A3DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1501,
    style: {
      stopColor: "#13ABC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285,
    style: {
      stopColor: "#1CB1BE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4744,
    style: {
      stopColor: "#22B4B7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#23B5B5"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M470.3,148.5v8.1h-35.2v-3.4c10.7-13.4,26.4-13.4,26.4-25.1c0-5.1-4.1-9.2-9.1-9.2    c-4,0-8.8,2.9-8.9,9.1v0.5h-8.4v-1c0-9.9,8.1-17.1,17.5-17.1c9.3,0,17.7,7.4,17.7,17.2c0,14.5-15.4,18.9-18.5,21.1H470.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047035880378413726590000001048612830580336288_",
    gradientUnits: "userSpaceOnUse",
    x1: 471.4404,
    y1: 133.6455,
    x2: 512.2421,
    y2: 133.6455
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#009FE3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04166079,
    style: {
      stopColor: "#07A3DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1501,
    style: {
      stopColor: "#13ABC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285,
    style: {
      stopColor: "#1CB1BE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4744,
    style: {
      stopColor: "#22B4B7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#23B5B5"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000047035880378413726590000001048612830580336288_)",
    d: "M512.2,138.8v7.8h-6.4v9.9h-9v-9.9h-23.7    l-1.7-4.2l27.3-31.7h7.1v28.1H512.2z M496.8,138.8v-14.1l-12.1,14.1H496.8z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5273f5dfcb770fa5ba3a689d666fecdb.svg";
export { ForwardRef as ReactComponent };